import { render } from "./PreviousDocumentPicker.vue?vue&type=template&id=bb20342c&scoped=true"
import script from "./PreviousDocumentPicker.vue?vue&type=script&lang=js"
export * from "./PreviousDocumentPicker.vue?vue&type=script&lang=js"

import "./PreviousDocumentPicker.vue?vue&type=style&index=0&id=bb20342c&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb20342c"]])

export default __exports__